import i18n from "config/i18next";

i18n.addResources("es", "login", {
  user: "Usuario",
  password: "Contraseña",
  forgotPassword: "¿Olvidaste tu contraseña?",
  login: "Iniciar sesión",
  countryOfOperation: "¿Desde qué país estás operando?",
  invalidTitle: "Usuario y/o contraseña inválidos",
  invalidMessage:
    "Tu usuario y/o contraseña ingresados son incorrectos. Por favor, ingresalos nuevamente.",
  invalidCountryTitle: "No tenés permisos",
  invalidCountryMessage:
    "Asegurate de elegir un país donde tengas un rol como persona usuaria.",
});
